import { render, staticRenderFns } from "./CardRequestsSteps.vue?vue&type=template&id=bf12ea00&"
import script from "./CardRequestsSteps.vue?vue&type=script&lang=js&"
export * from "./CardRequestsSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports